import { render, staticRenderFns } from "./PeriodPicker.vue?vue&type=template&id=5bc47cd6&scoped=true&"
import script from "./PeriodPicker.vue?vue&type=script&lang=js&"
export * from "./PeriodPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc47cd6",
  null
  
)

export default component.exports